/**
 * Returns the single Deutsche Bahn offer from the provider info response (`items[0]`),
 * or `null` when `items` is missing or empty — the page then shows "not available".
 */
export function getDeutscheBahnOffer(providerData: any): any | null {
  const items = providerData?.items;

  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return items[0] ?? null;
}
